import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';

import { logOut } from '../../../../routes/public/Login/actions'
import { withUser } from '../../../../components/Utils';
import { limpaAppBarValues } from '../../../actions';

import configs from '../../../../routes'
import { getConfigsDinamic } from '../../../../routes/sistema/DinamicForms/functions'

import styles from './styles'

import { withRouter } from 'react-router-dom';
const mapStateToProps = (state, props) => {

    const itens = []
    addMenus(configs, itens)
    addMenus(getConfigsDinamic(state), itens)

    return { itens };
};


export default compose(
    withRouter,
    withUser,
    // withPerfilUser,
    connect(mapStateToProps, { logOff: logOut, limpaAppBarValues }),
    withStyles(styles),

);
function addMenus(configs, itensMenu) {


    if (configs.menu) {
        let subDe = configs.menu.subDe
        if (subDe) {
            // console.log("subDe", subDe);
            itensMenu.push(configs.menu);
        } else {
            itensMenu.push(configs.menu);
        }


    }
    if (configs.subConfig) {
        configs.subConfig.forEach(((sub, i) => addMenus(sub, itensMenu)))
    }
}




// WEBPACK FOOTER //
// ./src/App/components/Menu/components/Menu.enhancer.js